import React, { useState } from 'react';
import './ActivationCodeScreen.css';

const ActivationCodeScreen = ({ onComplete, onBack }) => {
  const [code, setCode] = useState('');
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  // الكود الصحيح - يمكن تغييره لاحقاً أو جلبها من Firebase
  const CORRECT_CODE = 'UUXZCV7412';

  const handleSubmit = (e) => {
    e.preventDefault();
    setError('');

    if (!code.trim()) {
      setError('يرجى إدخال كود التفعيل');
      return;
    }

    setIsLoading(true);

    // محاكاة التحقق (يمكن استبدالها بطلب API)
    setTimeout(() => {
      if (code.trim() === CORRECT_CODE) {
        setIsLoading(false);
        onComplete();
      } else {
        setIsLoading(false);
        setError('كود التفعيل غير صحيح. يرجى المحاولة مرة أخرى');
        setCode('');
      }
    }, 500);
  };

  const handleCodeChange = (e) => {
    setCode(e.target.value);
    setError('');
  };

  return (
    <div className="activation-code-screen">
      <div className="activation-container">
        {/* Back Button */}
        {onBack && (
          <button 
            className="back-button ripple-effect magnetic-button" 
            onClick={onBack}
            aria-label="رجوع"
          >
            ← رجوع
          </button>
        )}

        {/* Header with Logo */}
        <div className="activation-header">
          <div className="logo-wrapper">
            <img src="/logo.jpeg" alt="شعار المدرسة" className="activation-logo" />
          </div>
        </div>

        {/* Main Content */}
        <div className="activation-content">
          <h2 className="activation-subtitle">مرحباً بك في</h2>
          <h1 className="activation-title">منصة المراجعات النهائية</h1>
          <p className="activation-description">بمتوسطة وثانوية نخبة الشمال الأهلية</p>
          
          <div className="activation-divider"></div>

          <div className="code-input-section">
            <label htmlFor="activation-code" className="code-label">
              أدخل كود التفعيل
            </label>
            <form onSubmit={handleSubmit} className="code-form">
              <div className="input-wrapper">
                <input
                  id="activation-code"
                  type="text"
                  className={`code-input ${error ? 'error' : ''}`}
                  value={code}
                  onChange={handleCodeChange}
                  placeholder="أدخل الكود هنا"
                  disabled={isLoading}
                  autoFocus
                  dir="ltr"
                />
                {error && (
                  <div className="error-message" role="alert">
                    {error}
                  </div>
                )}
              </div>
              <button
                type="submit"
                className={`submit-button ripple-effect magnetic-button pulse-element ${isLoading ? 'loading' : ''}`}
                disabled={isLoading || !code.trim()}
              >
                {isLoading ? 'جاري التحقق...' : 'تحقق'}
              </button>
            </form>
          </div>
        </div>

        {/* Footer */}
        <div className="activation-footer">
          <p>مدير المدرسة: محمد نصر الدين</p>
        </div>
      </div>
    </div>
  );
};

export default ActivationCodeScreen;

